import {
  UPLOAD_PROGRESS,
  UPLOAD_REQUEST,
  UPLOAD_SUCCESS,
  CSV_FIlE_SELECT,
  APP_LOGIN_EXPIRED
} from '../constants/action-types'

const defaultState = {
  appName: 'LMS Admin',
  token: null,
  csvUploadProgress: 0,
  csvFile: null,
  csvImportedResult: null,
  loginExpired: false
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case CSV_FIlE_SELECT: {
      return { ...state, csvFile: action.payload }
    }

    case UPLOAD_PROGRESS: {
      return { ...state, csvUploadProgress: action.payload }
    }

    case UPLOAD_REQUEST: {
      return { ...state, csvFile: action.payload, csvImportedResult: null }
    }

    case UPLOAD_SUCCESS: {
      return { ...state, csvImportedResult: action.payload }
    }

    case APP_LOGIN_EXPIRED: {
      return { ...state, loginExpired: action.payload }
    }

    default:
      return state
  }
}
